import { GetFrontRichiesteParams } from '@framework/api-client';
import {
  ExportableFileType,
  ExportFileButton,
  mapSelectedFieldsToFileFields,
} from '@framework/common-web';
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useExportSubmissionFile } from './useExportSubmissionFile';

interface ExportSubmissionFileButtonProps {
  fileType: ExportableFileType;
  query: GetFrontRichiesteParams;
}

export function ExportSubmissionFileButton(
  props: ExportSubmissionFileButtonProps,
) {
  const { fileType, query } = props;

  const [isOpen, setIsOpen] = useState(false);

  const [exportAll, setExportAll] = useState(false);

  const [selectedFields, setSelectedFields] = useState<string[]>([]);
  const fieldsQuery = useQuery(
    fileType.getGetFrontRichiesteFileCampiQueryOptions(),
  );
  const fields = fieldsQuery.data;

  const exportQuery = useMemo(() => {
    return {
      ...query,
      visibleFields: mapSelectedFieldsToFileFields(selectedFields, fields),
    };
  }, [query, selectedFields, fields]);

  const { download, isFetching, isLoading } = useExportSubmissionFile({
    fileType,
    exportAll,
    query: exportQuery,
    setExportAll,
    setIsOpen,
  });

  return (
    <ExportFileButton
      type={fileType.type}
      download={download}
      isFetching={isFetching}
      isLoading={isLoading}
      pageSize={query.limite}
      page={query.pagina}
      entity={'procedimenti'}
      exportAll={exportAll}
      setExportAll={setExportAll}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isSelectLoading={fieldsQuery.isFetching}
      onSelect={setSelectedFields}
      selected={selectedFields}
      fields={fields}
    />
  );
}
